import React from "react";
import AdminOrgChartView from "./AdminOrgChartView";
import { VACACIONES } from "Shared/Routing/Application/Constants/PathsConstant";

const AdminVacacionesOrgChartView = () => {
  return (
    <AdminOrgChartView
      fixedChartType="VACACIONES"
      adminTitle="Administrador de Vacaciones"
      adminDescription="Gestiona la estructura de vacaciones. Solo se permiten nodos raiz dentro de VACACIONES."
      allowNewStructure={false}
      allowStructureRenameDelete={false}
      allowBuilderPanel={false}
      allowChildCreation={true}
      allowEmployeeAssignment={false}
      allowReparenting={true}
      rootButtonLabel="Crear nodo de VACACIONES"
      autoCreateRootTitle="VACACIONES"
      rootDialogTitle="Nuevo Nodo de Vacaciones"
      rootDialogDescription="Se creara un nodo de vacaciones en nivel 0:"
      backToPath={VACACIONES}
    />
  );
};

export default AdminVacacionesOrgChartView;